import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NavDisplayService {
    hiddenRoutes = [
        'csr-external',
        'external-client-registration',
        'qp',
        'chatbot',
        'chatbot-container',
        'company-not-found',
        'agent-not-found',
        'awr',
        'avgRatesHistoric',
        'avgRates',
        'avgCompare',
        'monthlyCost'
    ];

    constructor() { }

    shouldHideNav(route): boolean {
        return this.hiddenRoutes.includes(route);
    }

    shouldShowNav(route): boolean {
        return !this.hiddenRoutes.includes(route);
    }
}
